<template>
  <div id="searchRecipes">
    <!--  搜索  -->
    <search :focus="true" @onSearch="onSearch"></search>
  </div>
</template>

<script>
import search from "@/components/contents/babyFeeding/search";
import {BuiedPointClick_Fn, Exposurer_feeding_Fn} from "@assets/js/BuriedPointEvent";

export default {
  name: "searchRecipes",
  data() {
    return {
      babyFeedYue: JSON.parse(localStorage.getItem('babyFeedYue')) || {}
    }
  },
  components: {
    search
  },
  methods: {
    onSearch(value) {
      BuiedPointClick_Fn('xmhh5_bbsp_serch_click', {
        xmhh5_bbsp_searchword: value
      })
      if (value) {
        this.$router.replace("/searchResultsPage?searchText=" + value)
      } else {
        this.$toast('请输入搜索内容进行搜索哦');
      }

    }
  },
  mounted() {
    Exposurer_feeding_Fn.observe('xmhh5_bbsp_allpageview', '.baby_feed_Index', false, {
      xmhh5_bbsp_pagename: '食谱搜索',
      xmhh5_bbsp_monthage: this.babyFeedYue?.name || "",
      xmhh5_bbsp_title: ""
    })
  },
}
</script>

<style lang="less" scoped>
#searchRecipes {
  background: #fff;
  height: 100%;
  flex: 1
}
</style>